import { Card } from "@mui/material";
import styled from "styled-components";

export const CardStyled = styled(Card)`
  padding: 24px;
  border-radius: 10px;

  .form-wrapper {
    padding-top: 24px;
    padding-bottom: 16px;
  }

  @media (max-width: 768px) {
    padding: 10px;
    .form-wrapper {
      padding-bottom: 10px;
    }
  }
`;
